﻿'use strict';

angular.module('ntmApp').factory('ComplexCondition', ['ComplexSearchConstants', function (ComplexSearchConstants) {

    function ComplexCondition(conditionCallback) {

        var self = this;

        self.setFieldType = function (fieldType) {

            self.selectedFieldType = fieldType;
            self.selectedFieldType.properties = self.selectedFieldType.properties ? JSON.parse(self.selectedFieldType.properties) : {};

            var defaultOperator = ComplexSearchConstants.OperatorsOfControlType.getOperators(self.selectedFieldType.type).defaultOperator;

            if (defaultOperator) {
                self.selectedOperator = defaultOperator;
            }

            clearValues();
        };

        self.setOperator = function (operator) {
            self.selectedOperator = operator;
            clearValues();
        };

        self.getCalendarOperators = function () {
            return ComplexSearchConstants.OperatorsOfControlType.getCalendarOperators().operators;
        };

        self.getOperators = function () {

            if (self.selectedFieldType && self.selectedFieldType.type) {
                return ComplexSearchConstants.OperatorsOfControlType.getOperators(self.selectedFieldType.type).operators;
            }

            return [];
        };

        self.hasOperators = function () {
            return ComplexSearchConstants.OperatorsOfControlType.hasOperators(self.selectedFieldType.type);
        };

        self.conditionChanges = function () {
            if (conditionCallback) {
                conditionCallback(self);
            }
        };

        self.isRange = function () {

            if (self.selectedOperator) {
                return self.selectedOperator.value === ComplexSearchConstants.Operators.BETWEEN.value;
            }

            return false;
        };

        self.isDateSpecific = function () {

            if (self.selectedOperator) {
                return ComplexSearchConstants.OperatorsOfControlType.getDateSpecificOperators().map(function (item) {
                    return item.value;
                }).indexOf(self.selectedOperator.value) !== -1;
            }

            return false;
        };

        self.isDateSpecificRange = function () {

            if (self.selectedOperator) {
                return ComplexSearchConstants.OperatorsOfControlType.getDateSpecificRangeOperators().map(function (item) {
                    return item.value;
                }).indexOf(self.selectedOperator.value) !== -1;
            }

            return false;
        };

        self.getDateSpecificRange = function () {
            
            switch (self.selectedOperator.value) {
                case ComplexSearchConstants.Operators.THIS_WEEK.value:
                    return {
                        from: moment().isoWeekday(0).startOf('day'),
                        to: moment().isoWeekday(6).startOf('day')
                    };
                case ComplexSearchConstants.Operators.NEXT_WEEK.value:
                    return {
                        from: moment().add(7, 'day').isoWeekday(0).startOf('day'),
                        to: moment().add(7, 'day').isoWeekday(6).startOf('day')
                    };
                case ComplexSearchConstants.Operators.THIS_MONTH.value:
                    return {
                        from: moment().startOf('month').startOf('day'),
                        to: moment().endOf('month').startOf('day')
                    };
                case ComplexSearchConstants.Operators.NEXT_MONTH.value:
                    return {
                        from: moment().add(1, 'months').startOf('month').startOf('day'),
                        to: moment().add(1, 'months').endOf('month').startOf('day')
                    };
                case ComplexSearchConstants.Operators.MONTH_AFTER_NEXT.value:
                    return {
                        from: moment().add(2, 'months').startOf('month').startOf('day'),
                        to: moment().add(2, 'months').endOf('month').startOf('day')
                    };
                case ComplexSearchConstants.Operators.THIS_YEAR.value:
                    return {
                        from: moment().startOf('year').startOf('day'),
                        to: moment().endOf('year').startOf('day')
                    };
                case ComplexSearchConstants.Operators.LAST_WEEK.value:
                    return {
                        from: moment().subtract(7, 'day').isoWeekday(0).startOf('day'),
                        to: moment().subtract(7, 'day').isoWeekday(6).startOf('day')
                    };
                case ComplexSearchConstants.Operators.LAST_MONTH.value:
                    return {
                        from: moment().subtract(1, 'months').startOf('month').startOf('day'),
                        to: moment().subtract(1, 'months').endOf('month').startOf('day')
                    };
                case ComplexSearchConstants.Operators.LAST_YEAR.value:
                    return {
                        from: moment().subtract(1, 'years').startOf('year').startOf('day'),
                        to: moment().subtract(1, 'years').endOf('year').startOf('day')
                    };
                case ComplexSearchConstants.Operators.CURRENT_USDA_YEAR.value:

                    if (parseInt(moment().format('M')) < 10) {
                        return {
                            from: moment([(parseInt(moment().format('YYYY')) - 1).toString(), '9', '1']).startOf('day'),
                            to: moment([moment().format('YYYY'), '8', '30']).startOf('day')
                        };
                    } 

                    return {
                        from: moment([moment().format('YYYY'), '9', '1']).startOf('day'),
                        to: moment([(parseInt(moment().format('YYYY')) + 1).toString(), '8', '30']).startOf('day')
                    };
                case ComplexSearchConstants.Operators.LAST_USDA_YEAR.value:

                    var previousYear = moment().subtract(1, 'years');

                    if (parseInt(previousYear.format('M')) < 10) {
                        return {
                            from: moment([(parseInt(previousYear.format('YYYY')) - 1).toString(), '9', '1']).startOf('day'),
                            to: moment([previousYear.format('YYYY'), '8', '30']).startOf('day')
                        };
                    }

                    return {
                        from: moment([previousYear.format('YYYY'), '9', '1']).startOf('day'),
                        to: moment([(parseInt(previousYear.format('YYYY')) + 1).toString(), '8', '30']).startOf('day')
                    };
                default: return {
                    from: null,
                    to: null
                };
            }
        };

        self.getSingleSpecificDate = function () {

            switch (self.selectedOperator.value) {
                case ComplexSearchConstants.Operators.TODAY.value:
                    return moment().startOf('day');
                case ComplexSearchConstants.Operators.TOMORROW.value:
                    return moment().add(1, 'day').startOf('day');
                case ComplexSearchConstants.Operators.YESTERDAY.value:
                    return moment().subtract(1, 'day').startOf('day');
                default: return null;
            }
        };

        self.getControlTemplate = function () {

            if (self.selectedFieldType) {
                
                switch (self.selectedFieldType.type) {
                    case ComplexSearchConstants.ControlTypes.TEXT:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/text.html';
                    case ComplexSearchConstants.ControlTypes.NUMERIC:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/numeric.html';
                    case ComplexSearchConstants.ControlTypes.CHECKBOX:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/checkbox.html';
                    case ComplexSearchConstants.ControlTypes.PICKLIST:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/picklist.html';
                    case ComplexSearchConstants.ControlTypes.DROPLIST:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/droplist.html';
                    case ComplexSearchConstants.ControlTypes.CHECKBOXLIST:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/checkboxlist.html';
                    case ComplexSearchConstants.ControlTypes.AUTOCOMPLETE:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/autocomplete.html';
                    case ComplexSearchConstants.ControlTypes.DATE:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/date.html';
					case ComplexSearchConstants.ControlTypes.RADIO:
					    return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/radio.html';
                    case ComplexSearchConstants.ControlTypes.RADIOBOOLEAN:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/radioboolean.html';
                    default:
                        return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/empty.html';
                }
            }

            return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/empty.html';
        };

        self.asText = function (isLast, length) {
            return '{0}{1} {2} {3}{4} {5} '.format(self.openingParenthesis && length > 2 ? self.openingParenthesis : '',
                                                   self.selectedFieldType ? self.selectedFieldType.name || '' : '',
                                                   getOperatorLabel(),
                                                   getValueForText(),
                                                   self.closingParenthesis && length > 2 ?  self.closingParenthesis : '',
                                                   isLast || !self.conditionalOperator ? '' : self.conditionalOperator);
        };

        self.getValue = function () {
            switch (self.selectedFieldType.type) {
                case ComplexSearchConstants.ControlTypes.RADIOBOOLEAN:
                    return self.value === "Yes" ? true : false;
                case ComplexSearchConstants.ControlTypes.DATE:
                    return moment(self.value).add(moment().hour(), 'hours');
                default:
                    return self.value.id || self.value;
            }
        };

        self.multiSelectSettings = {
            idProp: 'id',
            displayProp: 'value',
            attachDisplayProp: true,
            smartButtonMaxItems: 10,
            scrollableHeight: '200px',
            enableSearch: true
        };

        self.getSimpleDisplayChip = function () {
            var valueForText = getValueForSimpleDisplayChipText();

            if (valueForText && valueForText !== '') {
                switch (self.selectedFieldType.type) {
                    case ComplexSearchConstants.ControlTypes.PICKLIST:
                    case ComplexSearchConstants.ControlTypes.DROPLIST:
                    case ComplexSearchConstants.ControlTypes.AUTOCOMPLETE:
                    case ComplexSearchConstants.ControlTypes.RADIO:
                    case ComplexSearchConstants.ControlTypes.TEXT:
                    case ComplexSearchConstants.ControlTypes.CHECKBOXLIST:
                        return '{0}{1} {2}{3} {4} '.format(self.openingParenthesis || '',
                                                           self.selectedOperator ? self.selectedOperator.label || '' : '',
                                                           valueForText,
                                                           self.closingParenthesis || '',
                                                           self.conditionalOperator || '');
                    case ComplexSearchConstants.ControlTypes.RADIOBOOLEAN:
                    case ComplexSearchConstants.ControlTypes.CHECKBOX:
                        return '{0}{1}: {2} {3}{4} {5} '.format(self.openingParenthesis || '',
                                                               self.selectedFieldType ? self.selectedFieldType.name || '' : '',
                                                               self.selectedOperator ? self.selectedOperator.label || '' : '',
                                                               valueForText,
                                                               self.closingParenthesis || '',
                                                               self.conditionalOperator || '');
                    case ComplexSearchConstants.ControlTypes.NUMERIC:
                        if (self.isRange()) {
                            return '{0} {1} {2}{3} {4} '.format(self.openingParenthesis || '',
                                                               self.selectedFieldType ? self.selectedFieldType.name || '' : '',
                                                               valueForText,
                                                               self.closingParenthesis || '',
                                                               self.conditionalOperator || '');
                        }
                        return '{0}{1} {2} {3}{4} {5} '.format(self.openingParenthesis || '',
                                                           self.selectedFieldType ? self.selectedFieldType.name || '' : '',
                                                           self.selectedOperator ? self.selectedOperator.label || '' : '',
                                                           valueForText,
                                                           self.closingParenthesis || '',
                                                           self.conditionalOperator || '');
                    case ComplexSearchConstants.ControlTypes.DATE:
                        if (self.isRange()) {
                            return '{0} {1}: {2}{3} {4} '.format(self.openingParenthesis || '',
                                                               self.selectedFieldType ? self.selectedFieldType.name || '' : '',
                                                               valueForText,
                                                               self.closingParenthesis || '',
                                                               self.conditionalOperator || '');
                        }
                        return '{0}{1} {2} {3}{4} {5} '.format(self.openingParenthesis || '',
                                                           self.selectedFieldType ? self.selectedFieldType.name || '' : '',
                                                           self.selectedOperator ? self.selectedOperator.label || '' : '',
                                                           valueForText,
                                                           self.closingParenthesis || '',
                                                           self.conditionalOperator || '');
                }
            }

            return '';
        };

        function getValueForSimpleDisplayChipText() {

            if (self.isDateSpecific()) {
                return '';
            }

            if (self.isRange()) {
                if (self.from && self.to) {
                    if (self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.DATE) {
                        return '{0} - {1}'.format(formatValueForSimpleDisplayChipText(self.from), formatValueForSimpleDisplayChipText(self.to));
                    } else {
                        return '>= {0} and <= {1}'.format(formatValueForSimpleDisplayChipText(self.from), formatValueForSimpleDisplayChipText(self.to));
                    }
                }

                return '';
            }

            if (self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.CHECKBOX) {
                if (self.value === true) {
                    return 'Yes';
                }
                return '';
            }

            if (self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.CHECKBOXLIST && self.value.length > 0) {
                var resultString = '';
                self.value.forEach(function (item, itemIndex, valuesArray) { resultString += itemIndex !== valuesArray.length - 1 ? item.value + '; ' : item.value; });

                return resultString;
            }

            return self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.AUTOCOMPLETE ||
                   self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.PICKLIST ?
                            formatValueForSimpleDisplayChipText(self.value ? self.value.value : '') :
                            formatValueForSimpleDisplayChipText(self.value);
        }

        function getOperatorLabel() { 
            if(!self.selectedOperator) {
                return '';
            }

            if(self.isDateSpecific()){
                return '"{0}"'.format(self.selectedOperator.label);
            }

            return self.selectedOperator.label;
        }

        function getValueForText() {

            if (self.isDateSpecific()) {
                return '';
            }

            if (self.isRange()) {
                if (self.from && self.to) {
                    return '({0}, {1})'.format(formatValueForText(self.from), formatValueForText(self.to));
                }

                return '';
            }

            if (self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.CHECKBOXLIST && self.value) {
                var resultString = '';
                self.value.forEach(function (item) { resultString += item.value + '; '; });

                return resultString;
            }

            return self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.AUTOCOMPLETE ||
                   self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.PICKLIST ?
                            formatValueForText(self.value ? self.value.value : '') :
                            formatValueForText(self.value);
        }

        function formatValueForSimpleDisplayChipText(value) {

            if (!value) {
                return '';
            }

            if (self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.DATE) {

                var formattedDate = moment(value).format('MM/DD/YYYY');
                return '{0}'.format(formattedDate);
            }

            return '{0}'.format(value);
        }

        function formatValueForText(value) {

            if (!value) {
                return '';
            }

            if (self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.DATE) {

                var formattedDate = moment(value).format('MM/DD/YYYY');
                return '"{0}"'.format(formattedDate);
            }

            if (self.selectedFieldType.type === ComplexSearchConstants.ControlTypes.NUMERIC) {
                return value;
            }

            return '"{0}"'.format(value);
        }

        function clearValues() {
            self.value = null;
            self.from = null;
            self.to = null;
        }

        function initialize() {
            self.openingParenthesis = '';
            self.selectedFieldType = { };
            self.selectedOperator = '';
            self.closingParenthesis = '';
            self.conditionalOperator = 'AND';
        }

        initialize();
    }

    return (ComplexCondition);
}]);